import { Breadcrumb } from 'antd';
import styled from 'styled-components';

export const BaseWrapper = styled(Breadcrumb)`
  &.large {
    .ant-breadcrumb-link a,
    .current {
      font-size: 16px;
      padding: 0 18px;
    }

    .ant-breadcrumb-separator svg {
      width: 6px;
    }

    &.isLabel {
      .ant-breadcrumb-link a,
      .current {
        height: 44px;
      }

      ol {
        gap: 20px;
      }
    }
  }

  &.small {
    .ant-breadcrumb-link a,
    .current {
      font-size: 12px;
      padding: 0 10px;
    }

    .ant-breadcrumb-separator svg {
      width: 4px;
    }

    .ant-breadcrumb-separator svg {
      width: 4px;
    }

    &.isLabel {
      .ant-breadcrumb-link a,
      .current {
        height: 28px;
      }

      ol {
        gap: 10px;
      }
    }
  }
`;

export const BreadcrumbWrapper = styled(BaseWrapper)`
  .ant-breadcrumb-link a {
    border-radius: 8px;

    &:hover {
      text-decoration: underline;
    }
  }

  li {
    display: flex;
    align-items: center;
  }
`;

export const BreadcrumbLabelWrapper = styled(BaseWrapper)`
  width: fit-content;

  ol {
    flex-direction: column;
    gap: 14px;
  }

  .ant-breadcrumb-separator {
    display: none;
  }

  .ant-breadcrumb-link a {
    height: 32px;
    padding: 0 14px;
    margin: 0;
    border-radius: 8px;

    justify-content: center;

    &:hover {
      background-color: var(--light-gray);
    }
  }
`;

export const BreadcrumbCurrent = styled.div`
  color: var(--primary);
  padding: 0 16px;
  height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  &.label {
    height: 32px;
    border-radius: 8px;

    font-size: 14px;
    cursor: pointer;

    &:hover {
      background: var(--light-pink);
    }
  }
`;
